export {default} from './ChatInput';



// WEBPACK FOOTER //
// ./src/components/ChatUI/ChatInput/index.ts